window.axios = require('axios');

window.addEventListener('widgetsLoaded', function() {
    // One Trust
    if (window.OneTrustEnabled === true) {
        let script = document.createElement("script");
        script.type = "text/javascript";
        script.async = true;
        script.setAttribute("src", "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js");
        script.setAttribute("charset", "UTF-8");
        script.setAttribute("data-domain-script", "b0831070-5d7b-4d8f-a6cb-25b7e04d0b3c");

        document.head.appendChild(script);

        function OptanonWrapper() {
        }

        let script2 = document.createElement("script");
        script2.type = "text/javascript";
        script2.setAttribute("src", "https://cdn.cookielaw.org/consent/tcf.stub.js");
        script2.setAttribute("charset", "UTF-8");
        document.head.appendChild(script2);

        let script3 = document.createElement("script");
        script3.type = "text/javascript";
        script3.setAttribute("src", "https://consentag.eu/public/3.0.1/consenTag.js");
        document.head.appendChild(script3);
    }

    require('./bootstrap');
    require('slick-carousel');

    require('./components/sliders');
    require('./components/quick-search');
    require('./components/map');
    require('./components/perfect-scrollbar');

    require('./pages/news');
    require('./pages/contact');

    // OneTrust Cookie consent
    require('./components/onetrust');

    // Captcha
    require('./components/recaptcha');

    // GTM
    const gtm = document.querySelector("meta[name='gtm']");
    if (gtm) {
        let noscript = document.createElement("noscript");
        let iframe = document.createElement("iframe");
        iframe.style.display = "none";
        iframe.style.visibility = "hidden";
        iframe.src = 'https://www.googletagmanager.com/ns.html?id='+gtm.getAttribute("content");
        noscript.appendChild(iframe);
        document.body.insertBefore(noscript, document.body.firstChild);
    }
});

// Home page search
require('./components/google-places-search');

// Scroll to page top
var scrollTop = document.getElementById("scrollTop");
if (scrollTop !== null) {
    scrollTop.addEventListener("click", function(e) {
        e.preventDefault();
        window.scrollTo(0, 0);
    });
}
